import { throttle } from '../utils/utilities';

const SCROLLED_CLASS = 'is-scrolled';
const THRESHOLD = 24;

export default function Header(header) {
    if (!header) {
        return;
    }

    const update = () => {
        header.classList.toggle(SCROLLED_CLASS, window.scrollY > THRESHOLD);
    };

    update();

    window.addEventListener('scroll', throttle(update, 100), { passive: true });
}
